import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { FlexColumn, Flex } from '../Flex';

const ListContainer = styled(FlexColumn)`
  border: 1px solid ${({ theme }) => theme.palette.common.gray5};
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.common.white};
`;

const ListItem = styled(Flex)`
  min-height: 64px;
  height: auto;
  padding: 16px;
  align-items: center;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.common.gray5};
  }
`;

const AddSection = styled(FlexColumn)`
  cursor: pointer;
  font-weight: 600;
  text-decoration: underline;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.common.black};
  border-top: 1px solid ${({ theme }) => theme.palette.common.gray5};
  transition: background-color 0.2s;
  padding: 16px;
  &:hover {
    background-color: ${({ theme }) => theme.palette.common.gray6};
  }
`;

type AddableListProps = {
  children: ReactNode;
  onAdd: () => void;
  addButtonText: string;
  showAddButton?: boolean;
};

const AddableList = ({
  children,
  onAdd,
  addButtonText,
  showAddButton = true,
}: AddableListProps) => (
  <ListContainer>
    <FlexColumn>{children}</FlexColumn>
    {showAddButton && <AddSection onClick={onAdd}>{addButtonText}</AddSection>}
  </ListContainer>
);

export { AddableList, ListItem };
